import * as XLSX from "xlsx";

import { FRANCHISE_PORTAL_TITLE } from "@/common/constants";

export const downloadExcel = ({ filename, rows }) => {
    const data = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, data, "index");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
};

const strOrUndefined = (value) => {
    if (value === undefined || value === null) {
        return undefined;
    }
    return String(value);
};

export const parseFileMassiveLoadProductReferencesAndInventories = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const ab = event.target?.result;
            const wb = XLSX.read(ab, { type: "array" });
            const wsName = wb.SheetNames[0];
            if (wsName !== "products_inventories") {
                return reject(new Error("File is not equal to template"));
            }
            const ws = wb.Sheets[wsName];
            const data = XLSX.utils.sheet_to_json(ws, {
                header: [
                    "name",
                    "sku",
                    "barcode",
                    "price",
                    "stock",
                    "size",
                    "color",
                    "lineSlug",
                    "brandSlug",
                    "cost"
                ],
                blankrows: false
            });
            const rows = data.slice(4);
            const result = rows.map((row) => ({
                index: row.__rowNum__ + 1,
                item: {
                    name: `${row.name}`.trim(),
                    sku: `${row.sku}`.trim(),
                    barcode: `${row.barcode}`.trim(),
                    size: strOrUndefined(row.size),
                    price: Number(row.price || 0),
                    color: strOrUndefined(row.color),
                    lineSlug: `${row.lineSlug}`.trim(),
                    brandSlug: `${row.brandSlug}`.trim(),
                    cost: Number(row.cost || 0),
                    stock: Number(row.stock || 0)
                }
            }));
            resolve(result);
        };
        reader.readAsArrayBuffer(file);
        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const parseFileMassiveLoadProductAndReferences = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const ab = event.target?.result;
            const wb = XLSX.read(ab, { type: "array" });
            const wsName = wb.SheetNames[0];
            if (wsName !== "products") {
                return reject(new Error("File is not equal to template"));
            }
            const ws = wb.Sheets[wsName];
            const data = XLSX.utils.sheet_to_json(ws, {
                header: [
                    "name",
                    "sku",
                    "barcode",
                    "price",
                    "size",
                    "color",
                    "lineSlug",
                    "brandSlug",
                    "cost"
                ],
                blankrows: false
            });
            const rows = data.slice(4);
            const result = rows.map((row) => ({
                index: row.__rowNum__ + 1,
                item: {
                    name: `${row.name}`.trim(),
                    sku: `${row.sku}`.trim(),
                    barcode: `${row.barcode}`.trim(),
                    size: strOrUndefined(row.size),
                    price: Number(row.price || 0),
                    color: strOrUndefined(row.color),
                    lineSlug: `${row.lineSlug}`.trim(),
                    brandSlug: `${row.brandSlug}`.trim(),
                    cost: Number(row.cost || 0)
                }
            }));
            resolve(result);
        };
        reader.readAsArrayBuffer(file);
        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const parseFileMassiveLoadInventories = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const ab = event.target?.result;
            const wb = XLSX.read(ab, { type: "array" });
            const wsName = wb.SheetNames[0];
            if (wsName !== "inventories") {
                return reject(new Error("File is not equal to template"));
            }
            const ws = wb.Sheets[wsName];
            const data = XLSX.utils.sheet_to_json(ws, {
                header: ["barcode", "stock", "priceOffer", "cost"],
                blankrows: false
            });
            const rows = data.slice(4);
            const result = rows.map((row) => ({
                item: {
                    barcode: `${row.barcode}`,
                    stock: Number(row.stock || 1),
                    priceOffer: Number(row.priceOffer || 0),
                    cost: Number(row.cost || 0)
                },
                index: row.__rowNum__ + 1
            }));
            resolve(result);
        };
        reader.readAsArrayBuffer(file);
        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const parseFileMassivePrices = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const ab = event.target?.result;
            const wb = XLSX.read(ab, { type: "array" });
            const wsName = wb.SheetNames[0];
            if (wsName !== "references") {
                return reject(new Error("File is not equal to template"));
            }
            const ws = wb.Sheets[wsName];
            const data = XLSX.utils.sheet_to_json(ws, {
                header: ["barcode", "priceOffer", "price", "cost"],
                blankrows: false
            });
            const rows = data.slice(4);
            const result = rows.map((row) => ({
                index: row.__rowNum__ + 1,
                item: {
                    barcode: `${row.barcode}`.trim(),
                    price: Number(row.price || 0),
                    priceOffer: Number(row.priceOffer || 0),
                    cost:
                        row.cost !== undefined && row.cost !== ""
                            ? Number(row.cost)
                            : undefined
                }
            }));
            resolve(result);
        };
        reader.readAsArrayBuffer(file);
        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const downloadFileMassiveInventory = (filename, rows) => {
    const headers = [
        "Código de barras",
        "Stock",
        "Precio de venta",
        "Precio anterior",
        "Costo",
        "Nombre de producto",
        "Sku de producto",
        "Tamaño/Talla/Valor",
        "Color/Sabor",
        "Id de referencia",
        "Id de producto"
    ];
    const ws = XLSX.utils.aoa_to_sheet([
        headers,
        ...rows.map((row) => [
            row.barcode,
            row.stock,
            row.priceOffer,
            row.price,
            row.cost,
            row.name,
            row.sku,
            row.size,
            `${row.color} / ${row.colorRef}`,
            row.referenceId,
            row.productId
        ])
    ]);
    ws["!cols"] = headers.map(() => ({ width: 28 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inventarios");
    XLSX.writeFile(wb, `${filename}.xlsx`, {
        Props: { Author: FRANCHISE_PORTAL_TITLE }
    });
};

export const downloadFileMassiveProducts = (filename, rows) => {
    const headers = [
        "Nombre",
        "SKU",
        "Código de barras",
        "Precio anterior",
        "Precio de venta",
        "Stock",
        "Publicado",
        "Tamaño/Talla/Valor",
        "Color/Sabor",
        "Costo",
        "Marca",
        "Categoría",
        "Descripción",
        "Color HEX",
        "Orden"
    ];
    const ws = XLSX.utils.aoa_to_sheet([
        headers,
        ...rows.map((row) => [
            row.name,
            row.sku,
            row.barcode,
            row.price,
            row.priceOffer,
            row.stock,
            row.active ? "Sí" : "No",
            row.size,
            row.color,
            row.cost,
            row.brandSlug,
            row.lineSlug,
            row.summary,
            row.colorRef,
            row.weight
        ])
    ]);
    ws["!cols"] = headers.map(() => ({ width: 28 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Productos");
    XLSX.writeFile(wb, `${filename}.xlsx`, {
        Props: { Author: FRANCHISE_PORTAL_TITLE }
    });
};
